export const en = {
    ScopeSelector: {
        triggerAriaLabel: "Change scope, current selection {{current}}",
        reportsScopeAriaLabel: "Reports scope",
        scope: {
            myTeam: "My team",
            organization: "Everyone",
            allReports: "All reports",
            directReports: "Direct reports"
        },
        liveRegion: {
            loading: "Loading scope previews"
        }
    }
};
